import { useEnvironment } from '@wix/yoshi-flow-editor';
import React, { FC } from 'react';
import { Text } from 'wix-ui-tpa/cssVars';
import type { CourseItemViewModel } from '../../../../../../components/DailyAgenda/viewModel/agendaViewModel/agendaItemViewModel/agendaItemViewModel';
import { classes, st } from './CourseDetails.st.css';

export const COURSE_DATE_RANGE_DATA_HOOK = 'agenda-item-course-date-range';
export const COURSE_STATUS_DATA_HOOK = 'agenda-item-course-status';

export type CourseDetailsProps = {
  course?: CourseItemViewModel;
};

/**
 * The date range and the status of a course row. Renders nothing when `course`
 * is undefined, which covers a class and the experiment being off.
 *
 * Mobile never shows the status even when the owner turned it on
 * (Figma 4235-117673); Read more carries it there.
 */
export const CourseDetails: FC<CourseDetailsProps> = ({ course }) => {
  const { isMobile } = useEnvironment();

  if (!course) {
    return null;
  }

  return (
    <div className={st(classes.root, { isMobile })}>
      {course.dateRange && (
        <Text
          data-hook={COURSE_DATE_RANGE_DATA_HOOK}
          className={classes.dateRange}
        >
          {course.dateRange}
        </Text>
      )}
      {course.statusText && !isMobile && (
        <Text data-hook={COURSE_STATUS_DATA_HOOK} className={classes.status}>
          {course.statusText}
        </Text>
      )}
    </div>
  );
};
